import { TransferOrderUpdatePage } from "@/features/transfer-order/pages/TransferOrderUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/transfer-order/$id/update")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["transfer_order.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TransferOrderUpdatePage,
});
